import React from "react";
import { processSteps } from "../../data/process";
import { images } from "../../data/images";
export function ProcessSection() {
  return <section aria-labelledby="process-title" className="bg-olive text-paper" data-id="element-172" data-mp="guqz7owtylwc">
      <div className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32" data-id="element-173" data-mp="btjrtqylnoq7">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-center" data-id="element-174" data-mp="7u17awaoxfnw">
          <div className="lg:col-span-6" data-id="element-175" data-mp="2u6fmqj3cm1s">
            <h2 id="process-title" className="font-display text-5xl leading-[1.02] tracking-tight md:text-6xl" data-id="element-176" data-mp="2v82ds9gywzc">
              Du champ au flacon,
              <br data-id="element-177" data-mp="3u712oummk5ow" />
              <em data-id="element-178" data-mp="3p9hp7wxr3wy0">sans intermédiaire.</em>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-paper/80" data-id="element-179" data-mp="3pa0x0ktot4yb">
              Nous cultivons, récoltons, distillons et contrôlons sur le même site. Pour vous, c'est une traçabilité
              parcelle par parcelle et un interlocuteur unique, de la fiche technique à la livraison.
            </p>
          </div>
          <div className="lg:col-span-5 lg:col-start-8" data-id="element-180" data-mp="3od5fwsyfnxie">
            <div className="aspect-[4/3] overflow-hidden rounded-2xl lg:aspect-[5/4]" data-id="element-181" data-mp="3obm4pgrmwcnh">
              <img src={images.still} alt="Alambic en cuivre dans la distillerie du domaine" className="h-full w-full object-cover" data-id="element-182" data-mp="3t4njlorucc72" />
            </div>
          </div>
        </div>

        <ol className="mt-20 grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-8" data-id="element-183" data-mp="3jbq0phixsl7x">
          {processSteps.map((step, i) => <li key={step.title} className="border-t border-paper/25 pt-6" data-id="element-184" data-mp="fxvi3x1ktegf" data-mpi={i}>
              <span className="font-display text-lg italic text-paper/60" data-id="element-185" data-mp="1xksexc065wu">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-3 font-display text-3xl" data-id="element-186" data-mp="6w5ul2ateznx">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-paper/75" data-id="element-187" data-mp="6yibrd8r15zx">{step.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}